import * as PIXI from "pixi.js";
import { Signal } from "signals";


export default class SpriteMaskAnim extends PIXI.Sprite
{
    private _arrMask: Array<PIXI.Texture> = null;
    private _fps: number = null;
    
    private _curMaskIndex: number = null;

    private _elapsedTime: number = 0;

    private _onCompleted: Signal = null;


    public set fps( value: number ) { this._fps = value; }

    public get onCompleted(): Signal { return this._onCompleted; }


    public constructor( masks: Array<PIXI.Texture> )
    {
        super( masks[ 0 ] );

        this._arrMask = masks;
    }

    public init(): void
    {
        this._onCompleted = new Signal();
    }

    public end(): void
    {
        this._onCompleted.dispose();
        this._onCompleted = null;
    }

    public update( dt: number ): void
    {
        this._elapsedTime += dt;
        const kFrameStep: number = 1 / this._fps;
        if ( this._elapsedTime >= kFrameStep )
        {
            this._elapsedTime = this._elapsedTime - kFrameStep;

            this._curMaskIndex += 1;
            if ( this._curMaskIndex == this._arrMask.length )
            {
                this._onCompleted.dispatch();
            }
            else
            {
                this.texture = this._arrMask[ this._curMaskIndex ];
            }
        }
    }

    public reset(): void
    {
        this._elapsedTime = 0;
        this._curMaskIndex = 0;

        this.texture = this._arrMask[ 0 ];

        this._onCompleted.removeAll();
    }
}